/**
 * Enums canonicos do Zapir. FONTE DA VERDADE: docs/03-data-model.md (create type ...).
 * O teste anti-drift (docs/03 RNF-DB-012) compara estes valores com o banco.
 * Nao invente valores aqui: qualquer mudanca comeca no doc 03 e depois desce.
 */
import { z } from "zod";

export const tenantStatus = z.enum(["active", "suspended", "deleted"]);
export const userStatus = z.enum(["invited", "active", "disabled"]);
export const membershipRole = z.enum(["owner", "admin", "agent", "viewer"]);
export const membershipStatus = z.enum(["active", "suspended"]);
export const inviteStatus = z.enum(["pending", "accepted", "revoked", "expired"]);
export const sessionPlatform = z.enum(["web", "ios", "android"]);

export const channelType = z.enum(["whatsapp_waha"]);
export const channelStatus = z.enum(["pending", "connecting", "active", "stopped", "failed", "suspended"]);
export const channelDesiredState = z.enum(["running", "stopped"]);

export const wahaSessionStatus = z.enum([
  "STOPPED",
  "STARTING",
  "SCAN_QR_CODE",
  "PASSKEY_REQUIRED",
  "PASSKEY_CONFIRMATION_REQUIRED",
  "WORKING",
  "FAILED",
]);
export const sendBucket = z.enum(["cold", "warm"]);
export const waEngine = z.enum(["GOWS", "WEBJS", "NOWEB", "WPP"]);

export const conversationKind = z.enum(["direct", "group", "broadcast", "unknown"]);
export const conversationStatus = z.enum(["open", "pending", "snoozed", "closed"]);
export const participantRole = z.enum(["owner", "follower", "observer"]);

export const messageDirection = z.enum(["inbound", "outbound"]);
export const messageType = z.enum([
  "text",
  "image",
  "video",
  "audio",
  "voice",
  "document",
  "sticker",
  "location",
  "contact",
  "poll",
  "buttons",
  "list",
  "reaction",
  "system",
  "unknown",
]);
/** Estado NORMALIZADO (generico). O nivel nativo do provedor vive em message_acks.provider_level. */
export const messageStatus = z.enum(["pending", "sent", "delivered", "read", "played", "failed", "deleted", "revoked"]);
export const mediaStatus = z.enum(["pending", "ready", "failed", "purged"]);
export const storageProvider = z.enum(["s3", "local"]);
export const noteVisibility = z.enum(["team", "admins"]);
export const notificationType = z.enum(["new_message", "mention", "assignment", "unread_reminder", "number_down"]);
export const notificationStatus = z.enum(["pending", "sent", "delivered", "failed", "skipped"]);
export const devicePlatform = z.enum(["ios", "android", "web"]);
export const pushProvider = z.enum(["fcm", "apns", "webpush"]);
export const auditActorType = z.enum(["user", "superadmin", "system", "impersonation"]);
export const inboxStatus = z.enum(["received", "processing", "processed", "failed", "ignored"]);
export const outboxStatus = z.enum(["queued", "sending", "sent", "failed", "canceled"]);
export const outboxKind = z.enum([
  "text",
  "image",
  "video",
  "audio",
  "voice",
  "document",
  "sticker",
  "location",
  "contact",
  "reaction",
  "seen",
  "typing",
]);
export const outboundSource = z.enum(["zapir", "waha_api", "phone", "unknown"]);

export type TenantStatus = z.infer<typeof tenantStatus>;
export type UserStatus = z.infer<typeof userStatus>;
export type MembershipRole = z.infer<typeof membershipRole>;
export type InviteStatus = z.infer<typeof inviteStatus>;
export type ChannelType = z.infer<typeof channelType>;
export type ChannelStatus = z.infer<typeof channelStatus>;
export type ChannelDesiredState = z.infer<typeof channelDesiredState>;
export type WahaSessionStatus = z.infer<typeof wahaSessionStatus>;
export type SendBucket = z.infer<typeof sendBucket>;
export type WaEngine = z.infer<typeof waEngine>;
export type ConversationKind = z.infer<typeof conversationKind>;
export type ConversationStatus = z.infer<typeof conversationStatus>;
export type MessageDirection = z.infer<typeof messageDirection>;
export type MessageType = z.infer<typeof messageType>;
export type MessageStatus = z.infer<typeof messageStatus>;
export type MediaStatus = z.infer<typeof mediaStatus>;
export type NoteVisibility = z.infer<typeof noteVisibility>;
export type NotificationType = z.infer<typeof notificationType>;
export type NotificationStatus = z.infer<typeof notificationStatus>;
export type DevicePlatform = z.infer<typeof devicePlatform>;
export type PushProvider = z.infer<typeof pushProvider>;
export type AuditActorType = z.infer<typeof auditActorType>;
export type InboxStatus = z.infer<typeof inboxStatus>;
export type OutboxStatus = z.infer<typeof outboxStatus>;
export type OutboxKind = z.infer<typeof outboxKind>;
export type OutboundSource = z.infer<typeof outboundSource>;

/** Limites de produto fixados nos docs (nao duplicar numeros soltos pelo codigo). */
export const LIMITS = {
  /** docs/07 RF-COL-080: maximo de conversas fixadas por usuario. */
  PINNED_PER_USER: 20,
  /** docs/09 RF-UX-034: tamanho maximo de texto enviado. */
  MESSAGE_TEXT_MAX: 4096,
  /** docs/05: legenda maxima de mensagem com midia. */
  MESSAGE_CAPTION_MAX: 1024,
  /** docs/06 RF-MED-007: tamanho maximo de upload (base64 para o WAHA na v1). */
  MEDIA_UPLOAD_MAX_BYTES: 16 * 1024 * 1024,
  /** docs/09: paginacao padrao de listas. */
  PAGE_DEFAULT: 30,
  PAGE_MAX: 100,
} as const;
